import React, { useState } from 'react';

const SettingsColorPicker = ({ label, value, onChange, defaultValue }) => {
  const currentValue = value || defaultValue || '#000000';
  const [hexInput, setHexInput] = useState(currentValue);

  const handleHexChange = (e) => {
    const hex = e.target.value;
    setHexInput(hex);
    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
      onChange(hex);
    }
  };

  const handleColorInput = (e) => {
    const hex = e.target.value;
    onChange(hex);
    setHexInput(hex);
  };

  return (
    <div className="flex items-center gap-2 bg-dark-hover/40 rounded-lg px-2.5 py-2">
      <div className="relative">
        <input
          type="color"
          value={currentValue}
          onChange={handleColorInput}
          className="w-8 h-8 rounded-md border border-dark-border cursor-pointer"
        />
      </div>
      <div className="flex flex-col min-w-0">
        <span className="text-[11px] text-muted leading-tight">{label}</span>
        <input
          type="text"
          value={hexInput}
          onChange={handleHexChange}
          onBlur={() => setHexInput(currentValue)}
          className="text-xs text-label bg-transparent border-none p-0 w-[70px] font-mono focus:outline-none focus:text-primary"
          maxLength={7}
        />
      </div>
    </div>
  );
};

export default SettingsColorPicker;
